"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _getFormattedDuration = _interopRequireDefault(require("../date/getFormattedDuration"));

var _formatNumber = _interopRequireDefault(require("../char/formatNumber"));

var _formatDistanceWithMeasurementSystem = _interopRequireDefault(require("./formatDistanceWithMeasurementSystem"));

var formatRankingScoreByType = function formatRankingScoreByType(_ref) {
  var _ref$score = _ref.score,
      score = _ref$score === void 0 ? 0 : _ref$score,
      unit = _ref.unit,
      _ref$measurementSyste = _ref.measurementSystem,
      measurementSystem = _ref$measurementSyste === void 0 ? 'metric' : _ref$measurementSyste,
      sport = _ref.sport,
      locale = _ref.locale,
      _ref$durationUnit = _ref.durationUnit,
      durationUnit = _ref$durationUnit === void 0 ? 'milliseconds' : _ref$durationUnit;

  switch (unit) {
    case 'distance':
    case 'climb':
      return (0, _formatNumber["default"])((0, _formatDistanceWithMeasurementSystem["default"])({
        distance: score,
        measurementSystem: measurementSystem,
        unit: unit,
        sport: sport
      }), {
        locale: locale
      });

    case 'duration':
      return (0, _getFormattedDuration["default"])({
        duration: score,
        unit: durationUnit
      });

    default:
      return (0, _formatNumber["default"])(score, {
        locale: locale
      });
  }
};

var _default = formatRankingScoreByType;
exports["default"] = _default;
//# sourceMappingURL=formatRankingScoreByType.js.map